export default {
	tenantId: "gogox_uat",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "gogox--uat"
	}
}
